import {Component, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';

import {AuditService} from '../../audit.service';
import {Audit} from '../../audit.model';
import {BreadcrumbItem} from '../../../shared/shared.model';
import {AuditEditFormComponent} from '../audit-edit-form/audit-edit-form.component';

@Component({
  selector: 'iaud-audit-add',
  templateUrl: './audit-add.component.html',
  styleUrls: ['./audit-add.component.scss'],
})
export class AuditAddComponent {
  isFormValid: boolean = false;
  isFinishLaterValid: boolean = false;
  isNextLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  isLaterLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  audit: Audit = {
    auditTitle: '',
    auditCode: '',
    auditTypeId: -1,
    auditType: '',
    auditDescription: '',
    auditOwnerGroup: '',
    auditOwnerGroupId: -1,
    dueDate: null,
    externalPartner: '',
    smeApprovers: [],
    status: 'draft',
    submiters:[],
    smeApprover:'',
    submiter:'',
    history : ''
  };

  breadcrumbs: Array<BreadcrumbItem> = [
    {
      title: 'Home',
      path: '/home',
    },
    {
      title: 'All audits',
      path: '/audit',
    },
    {
      title: 'New Audit',
      path: '/audit/add',
    },
  ];

  @ViewChild('editFormComponent') editFormComponent: AuditEditFormComponent;

  constructor(
    private router: Router,
    private auditService: AuditService
  ) {}

  submitAudit(later: boolean = false): void {
    if (!this.isFinishLaterValid) {
      this.editFormComponent.auditForm.get('title').markAsTouched();
      this.editFormComponent.auditForm.get('type').markAsTouched();
      this.editFormComponent.auditForm.get('ownerGroup').markAsTouched();
      this.editFormComponent.auditForm.get('dueDate').markAsTouched();

      return;
    }

    if (later) {
      this.isLaterLoading$.next(true);
    } else
      this.isNextLoading$.next(true);

    this.auditService.submitAudit(this.audit)
      .subscribe(response => {
        if (later)
          return this.router.navigateByUrl('/audit');

        return this.router.navigateByUrl(`/audit/${response}/finding/add`);
      });
  }

  toggleFormValidity(valid: boolean): void {
    this.isFormValid = valid;
  }

  toggleFinishLaterFormValidity(valid: boolean): void {
    this.isFinishLaterValid = valid;
  }
}
